module.exports = __webpack_public_path__ + "static/media/04-galeria-02-perisur-mobile@2x.95989b4a.jpg";